import React from 'react';
import { Container, Typography } from '@mui/material';

export default function Products() {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>Our Products</Typography>
      <Typography variant="body1">Explore our innovative products designed to empower your business.</Typography>
    </Container>
  );
}
